<!--     What is RegScale    -->
<div class="features-3">
    <div class="row">
      <div class="col-md-12">
        <div class="col d-flex align-items-center justify-content-center">
          <h2 class="title-meet">{{ strTitle }}</h2><br/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="video-responsive text-center">
          <iframe width="793" height="500" [src]="strLink | safeUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
